import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";

export const loadPumpData = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_PUMP_DATA}`, postData);
  return response.data;
};

export const loadPmpFreeGasCheck = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_PUMP_FREE_GAS_CHECK}`, postData);
  return response.data;
};

export const loadPumpCalcOutputLables = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_PUMP_CALC_LABLES}`, postData);
  return response.data;
};

export const loadPumpCalcOutputForCorrectionFactorOverride = async (
  postData: any
) => {
  const response = await http.post(
    `${ESP_ENDPOINTS?.GET_PUMP_CORRECTION_FACTOR_OVERRIDE}`,
    postData
  );
  return response.data;
};

export const loadPumpIteration = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_PUMP_ITERATION}`, postData);
  return response.data;
};

export const getAIPumpData = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_AI_PUMP_DATA}`, postData);
  return response.data;
};

export const loadPumpMaxCalc = async (
  pmpName: string,
  noOfStages: string,
  liqPhase: string,
  shaftType: string,
  liqPhseUnit: string,
  unitSys: string
) => {
  const params = {
    PmpName: pmpName,
    NoOfStages: noOfStages,
    LiqPhase: liqPhase,
    ShaftType: shaftType,
    LiqPhseUnit: liqPhseUnit,
    UnitSys: unitSys,
  };

  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PUMP_MAX_CALC}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error loading graph data:", error);
    throw error;
  }
};

export const converToOutUnit = async (postData: any) => {
  const response = await http.post(`${ESP_ENDPOINTS?.GET_CONVERT_UNIT}`, postData);
  return response.data;
};

// export const LoadPlot1Graph = async (
//   pmpID: string,
//   noOfStgs: number,
//   flowCorrection: number,
//   headCorrection: number,
//   powerCorrection: number,
//   fldSpGravity: number,
//   fldViscty: number,
//   motrSpd: number,
//   prodRate: number,
//   unitSys: number,
//   prodRateUnit: number,
//   opFreq: number,
//   fldVisctyUnit: number,
//   FinalDTH: number
// ) => {
//   const response = await http.post(`Determine/ESP/GetGraphData`, {
//     pmpID,
//     noOfStgs,
//     flowCorrection,
//     headCorrection,
//     powerCorrection,
//     fldSpGravity,
//     fldViscty,
//     motrSpd,
//     prodRate,
//     unitSys,
//     prodRateUnit,
//     opFreq,
//     fldVisctyUnit,
//     FinalDTH,
//   });
//   return response.data;
// };
export const LoadPlot1Graph = async (
  pmpID: string,
  noOfStgs: number,
  flowCorrection: number,
  headCorrection: number,
  powerCorrection: number,
  fldSpGravity: number,
  fldViscty: number,
  motrSpd: number,
  prodRate: number,
  unitSys: number,
  prodRateUnit: number,
  opFreq: number,
  fldVisctyUnit: number,
  FinalDTH: number
) => {
  const params = {
    pumpId: pmpID,
    NoOfStages: noOfStgs,
    flowCorrectionFactor: flowCorrection,
    headCorrectionFactor: headCorrection,
    powerCorrectionFactor: powerCorrection,
    FldSpGravity: fldSpGravity,
    FldViscty: fldViscty,
    MotrSpd: motrSpd,
    ProdctnRt: prodRate,
    UnitSys: unitSys,
    ProdctnRtUnit: prodRateUnit,
    OpFreq: opFreq,
    ViscoUnit: fldVisctyUnit,
    FinalTDH: FinalDTH,
  };
  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PUMP_GRAPH_ONE_DATA}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error loading graph data:", error);
    throw error;
  }
};
export const LoadCompositeGraph = async (postData: any) => {
  const response = await http.post(
    `${ESP_ENDPOINTS?.GET_PUMP_COMPOSITE_GRAPH_DATA}`,
    postData
  );
  return response.data;
};

export const LoadPlot2Graph = async (
  pmpID: string,
  noOfStgs: number,
  flowCorrection: number,
  headCorrection: number,
  powerCorrection: number,
  fldViscty: number,
  motrSpd: number,
  prodRate: number,
  unitSys: number,
  prodRateUnit: number,
  opFreq: number,
  fldVisctyUnit: number,
  FinalDTH: number

) => {
  const params = {
    pumpId: pmpID,
    NoOfStages: noOfStgs,
    flowCorrectionFactor: flowCorrection,
    headCorrectionFactor: headCorrection,
    powerCorrectionFactor: powerCorrection,
    FldViscty: fldViscty,
    MotrSpd: motrSpd,
    prodRate: prodRate,
    UnitSys: unitSys,
    ProdRateUnit: prodRateUnit,
    Frequency: opFreq,
    ViscoUnit: fldVisctyUnit,
    FinalTDH: FinalDTH,
  };
  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PUMP_GRAPH_TWO_DATA}`, { params });
    return response.data;
  }
  catch (error) {
    console.error("Error loading graph data:", error);
    throw error;
  }
};

export const LoadPlot3Graph = async (
  pmpID: string,
  noOfStgs: number,
  flowCorrection: number,
  headCorrection: number,
  powerCorrection: number,
  fldViscty: number,
  fldSpGravity: number,
  motrSpd: number,
  prodRate: number,
  unitSys: number,
  prodRateUnit: number,
  opFreq: number,
  fldVisctyUnit: number,
  FinalDTH: number
) => {
  const params = {
    pumpId: pmpID,
    NoOfStages: noOfStgs,
    flowCorrectionFactor: flowCorrection,
    headCorrectionFactor: headCorrection,
    powerCorrectionFactor: powerCorrection,
    FldSpGravity: fldSpGravity,
    FldViscty: fldViscty,
    MotrSpd: motrSpd,
    prodRate: prodRate,
    UnitSys: unitSys,
    ProdRateUnit: prodRateUnit,
    Frequency: opFreq,
    ViscoUnit: fldVisctyUnit,
    FinalTDH: FinalDTH,
  };
  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_PUMP_GRAPH_THREE_DATA}`, { params });
    return response.data;
  }
  catch (error) {
    console.error("Error loading graph data:", error);
    throw error;
  }
};

export const fetchBOHEquipments = async (pump: any, tubingOD: number) => {
  const params = {
    series: pump.pumpSeries,
    tubingOD: tubingOD,
    pumpName: pump.pumpName,
  };
  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_BOH}`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error loading graph data:", error);
    throw error;
  }
};

export const fetchEquipmentsForPumps = async (
  pumpName: string,
  catalogFilter: number
) => {
  return await http.get<any>(
    `${ESP_ENDPOINTS?.GET_SR_PUMP}` +
    pumpName +
    "&catalogFilter=" +
    catalogFilter
  );
};
